import { Constants300 } from './3.0.0/Constants300';
import { Constants302 } from './3.0.2/Constants302';
import { Constants402 } from './4.0.2/Constants402';
import { useVersion } from '../../versions/url-version';

export function Constants() {
  const version = useVersion();

  if (version === '3.0.0') {
    return <Constants300 />;
  }
  if (version === '3.0.2') {
    return <Constants302 />;
  }
  if (version === '4.0.2') {
    return <Constants402 />;
  }

  return <div>Constants documentation is not available for this version</div>;
}
